import React, { useState, useEffect } from 'react';
import api from '../services/api';

const CustomerMaster = () => {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Form
  const [editingId, setEditingId] = useState(null);
  const [Name, setName] = useState('');
  const [Address, setAddress] = useState('');
  const [MobileNo, setMobileNo] = useState('');

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const res = await api.get('/masters/customers');
      setCustomers(res.data);
    } catch (err) {
      setError('Failed to load customers');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      if (editingId) {
        await api.put(`/masters/customers/${editingId}`, { Name, Address, MobileNo });
        setSuccess('Customer updated successfully');
      } else {
        await api.post('/masters/customers', { Name, Address, MobileNo });
        setSuccess('Customer added successfully');
      }
      resetForm();
      fetchCustomers();
    } catch (err) {
      setError('Failed to save customer');
    }
  };

  const handleEdit = (c) => {
    setEditingId(c.Id);
    setName(c.Name || '');
    setAddress(c.Address || '');
    setMobileNo(c.MobileNo || '');
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete customer record?')) return;
    try {
      await api.delete(`/masters/customers/${id}`);
      setSuccess('Customer deleted');
      fetchCustomers();
    } catch (err) {
      setError('Failed to delete customer');
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setName('');
    setAddress('');
    setMobileNo('');
  };

  const filtered = customers.filter((c) =>
    (c.Name || '').toLowerCase().includes(search.toLowerCase()) ||
    (c.Address || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
        <div>
          <h3 className="fw-bold mb-1 text-primary">
            <i className="bi bi-people me-2"></i>Customer Master (व्यापारी)
          </h3>
          <p className="text-muted mb-0">Manage fish buyers, wholesalers, and contact details</p>
        </div>
      </div>

      {error && <div className="alert alert-danger py-2">{error}</div>}
      {success && <div className="alert alert-success py-2">{success}</div>}

      <div className="row g-4">
        {/* FORM */}
        <div className="col-12 col-md-4">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-primary text-white fw-bold">
              {editingId ? 'Edit Customer Details' : 'Add New Customer'}
            </div>
            <div className="card-body">
              <form onSubmit={handleSave}>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Customer Name (व्यापारी नांव)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. BABLU BHARDWAJ"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Address / Location</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. ALIBAG / PUNE / GUJRAT"
                    value={Address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Mobile Number"
                    value={MobileNo}
                    onChange={(e) => setMobileNo(e.target.value)}
                  />
                </div>

                <div className="d-flex gap-2">
                  <button type="submit" className="btn btn-primary w-100 fw-bold">
                    <i className="bi bi-check-circle me-1"></i> {editingId ? 'Update' : 'Save'}
                  </button>
                  {editingId && (
                    <button type="button" className="btn btn-outline-secondary" onClick={resetForm}>
                      Cancel
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* LIST */}
        <div className="col-12 col-md-8">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
              <h5 className="fw-bold mb-0 text-dark">
                Customer List ({filtered.length})
              </h5>
              <div className="w-50">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search customer..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
            <div className="table-responsive" style={{ maxHeight: '600px' }}>
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light sticky-top">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Address</th>
                    <th>Mobile No</th>
                    <th className="text-end">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4 text-muted">
                        <span className="spinner-border spinner-border-sm me-2"></span> Loading customer directory...
                      </td>
                    </tr>
                  ) : filtered.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4 text-muted">
                        No customers found.
                      </td>
                    </tr>
                  ) : (
                    filtered.map((c, idx) => (
                      <tr key={c.Id}>
                        <td>{idx + 1}</td>
                        <td className="fw-semibold text-primary">{c.Name}</td>
                        <td>{c.Address || '-'}</td>
                        <td>{c.MobileNo || '-'}</td>
                        <td className="text-end">
                          <button
                            className="btn btn-outline-primary btn-sm me-1"
                            onClick={() => handleEdit(c)}
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleDelete(c.Id)}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerMaster;
